import { Avatar, Flex } from 'antd';
import dayjs from 'dayjs';
import { observer } from 'mobx-react';
import { FC, useState } from 'react';
import { JobsDataType } from '../../../../ types';
import { StagesStore } from '../../../../../DataSource/Stores/Cabinet/StagesStore';
import { WorkspacesStore } from '../../../../../DataSource/Stores/Cabinet/WorkspacesStore';
import { config } from '../../../../../config';
import Button from '../../../../ui/Button';
import Icon from '../../../../ui/Icon';
import JobDrawer from '../../JobDrawer';
import * as styles from './index.module.scss';
import LabelList from './LabelList';
import TagList from './TagList';

interface IProps extends JobsDataType {
  _job: JobsDataType;
  dragProps: any;
}

const JobCard: FC<IProps> = ({
  _id,
  jobId,
  workspaceId,
  name,
  targetDate,
  assignedTo,
  labels,
  tags,
  _job,
  dragProps,
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const member = assignedTo ? WorkspacesStore.members[assignedTo]?.userId : null;

  const showModal = () => {
    setModalOpen(true);

    StagesStore.getJobsId(workspaceId, _id).catch((e) => {
      console.error(e);
    });
  };

  return (
    <>
      <div className={styles.jobCard}>
        <div className={styles.dragHandle} {...dragProps}>
          <Icon slug="drag_handle" />
        </div>
        <Flex vertical gap={16} style={{ width: 'calc(100% - 25px)' }}>
          <p className={styles.title}>{name}</p>

          <Flex vertical gap={8}>
            <Button variant="delivery_primary" autoWidth onClick={showModal}>
              #{jobId}
              <Icon slug="arrow_vertical" />
            </Button>

            <div className={styles.dateBlock}>
              {dayjs(targetDate).format('HH : mm')}
              <span className={styles.separator}>•</span>
              {dayjs(targetDate).format('DD/MM/YY')}
            </div>

            {member && (
              <Flex align="center" gap={8}>
                {member.photo && (
                  <Avatar
                    src={`${config.EXTERNAL_ADDRESS}/image-uploader/${member.photo}`}
                    shape="circle"
                    size={32}
                  />
                )}
                {!member.photo && <div className={styles.picture}>{member.firstname[0]}</div>}
                <p className={styles.name}>{member.firstname}</p>
              </Flex>
            )}

            {labels && <LabelList labels={labels} />}
            {!!tags?.length && <TagList tags={tags} />}
          </Flex>
        </Flex>
      </div>

      <JobDrawer {..._job} isOpen={modalOpen} onClose={() => setModalOpen(false)} />
    </>
  );
};

export default observer(JobCard);
